import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import liveSessioner from '../../../../services/livesession/LiveSessioner';

import styles from '../../testOverview.scss';
import idVerificationService from '../../../../services/idverification/IdVerificationService';

class PureIdVerificationStartButton extends React.PureComponent {
    static propTypes = {
        audioDeviceId: PropTypes.string,
        webcamDeviceId: PropTypes.string,
        label: PropTypes.string.isRequired,
        onStart: PropTypes.func.isRequired,
    };

    startButtonHandler = () => {
        const { onStart, audioDeviceId, webcamDeviceId } = this.props;
        onStart(audioDeviceId, webcamDeviceId);
    }

    render() {
        const { label } = this.props;

        return (
            <button
                className={`${styles.button} btn`}
                onClick={this.startButtonHandler}
            >
                {label}
            </button>
        );
    }
}

function mapStateToProps(state) {
    const { livestream: { audioDeviceId, webcamDeviceId } } = state;
    return {
        audioDeviceId,
        webcamDeviceId,
    };
}

function mapDispatchToProps() {
    return {
        onStart(audioDeviceId, webcamDeviceId) {
            // request access with previously saved devices
            liveSessioner.requestHardwareAccess(webcamDeviceId, audioDeviceId);
            idVerificationService.gotoPhotoRetake();
        },
    };
}

const IdVerificationStartButton = connect(
    mapStateToProps,
    mapDispatchToProps,
)(PureIdVerificationStartButton);

export default IdVerificationStartButton;
export { PureIdVerificationStartButton };
